export interface SocialProvider {
  name: string;
  icon: string;
  label: string;
}

export const useSocialAuthentication = () => {
  const providers: SocialProvider[] = [
    { name: 'google', icon: 'google', label: 'Google' },
    { name: 'apple', icon: 'apple', label: 'Apple' },
    { name: 'microsoft', icon: 'microsoft', label: 'Microsoft' },
  ];

  const statusMessages = {
    'account-already-linked': 'Your account is already linked with another provider. Please login with the provider you used to sign up.',
    'login-required-for-linking-social-account': 'You already have an account with us that has not been linked to this social provider. Please login with your email and password to link your social account.',
    'default': 'An error occurred while trying to login with your social account. Please try again later.',
  };

  const getStatusMessage = (eId: string, hint: string | null = null) => {
    const validEIds = Object.keys(statusMessages);
    const errorKey = (validEIds.includes(eId) ? eId : 'default') as keyof typeof statusMessages;

    if (eId === 'account-already-linked' && hint) {
      if (hint === 'b2b') {
        return "Your account is already linked with another provider.";
      } else {
        hint = hint.charAt(0).toUpperCase() + hint.slice(1);
        return `Your account is already linked with another provider. It looks like you have used ${hint} in the past.`;
      }
    }

    return statusMessages[errorKey];
  };

  const getSocialAuthenticationURL = (provider: string, target: 'login' | 'signup') => {
    return `/api/auth/social/${provider}?redirect_host=${encodeURIComponent(window.location.host)}&redirect_target=${encodeURIComponent(target)}`;
  };

  return {
    providers,

    getStatusMessage,
    getSocialAuthenticationURL,
  };
};
